import React, { useEffect, useState } from 'react';
import * as Tools from '../../helpers/Tools';
import { Icon, LinkText, Notifier } from "../ecosystem/";


const OutdatedBrowserNotifier = ({
    browserName,
    isEdgeBrowser,
    isIEBrowser,
    isMobile,
    showoutDatedMessage,
    hasLoginNotice
}) => {

    const chromeWebUrl = 'https://www.google.com/chrome/';
    const edgeWebUrl = 'https://www.microsoft.com/en-us/edge';
    const isChromeBrowser = browserName === 'Chrome';
    const isIos = Tools.isIos();
    const isSafariBrowser = browserName === 'Safari';

    const [showContent, setShowContent] = useState(false);
    const showAccordion = isMobile && hasLoginNotice; //Need to add check if LoginNotice is displaying
    const accordionCollapsed = showAccordion && !showContent ? true : false;

    const accordionClick = (showContent) => {
        if (showContent) {
            setShowContent(false);
        } else {
            setShowContent(true);
        }
    }

    const outdatedBannerMsgClasses = [
        `${(isMobile && !showAccordion) ? 'text-center' : ''}`,
        `${showAccordion ? `outdated-browser-accordion outdated-browser-accordion--${accordionCollapsed ? 'collapsed' : 'expanded'}` : ""}`
    ].join(' ');

    return (showoutDatedMessage &&
        <Notifier
            variant="banner"
            icon={!isMobile ? "information" : ''}

        >
            <div className="outdated-browser-notifier-container">
                <div className={outdatedBannerMsgClasses}
                >
                    <div className="banner-msg">
                        Your browser is outdated and may prevent MyBSWHealth features from working properly. For best results,&nbsp;  
                    {isIos ? (
                        isSafariBrowser ? (
                            'update Safari'
                        ) : (
                            'use Safari'
                        )
                    ) : (
                        <>
                            {!isEdgeBrowser && !isChromeBrowser && <>use </>}
                            {
                                <LinkText
                                    href={
                                        isIEBrowser || isEdgeBrowser
                                            ? edgeWebUrl
                                            : chromeWebUrl
                                    }
                                    target="_blank"
                                    color="$color-primary-a2"
                                    underline="always"
                                >
                                    {isIEBrowser
                                        ? 'Edge'
                                        : isEdgeBrowser
                                            ? 'update your browser'
                                            : isChromeBrowser
                                                ? 'update your browser'
                                                : 'Chrome'}
                                </LinkText>
                            }
                        </>
                    )}
                        .
                        {accordionCollapsed && <span className="banner-msg-ellipsis">...</span>}
                    </div>   
                    {showAccordion &&
                        <button type="button" className="accordion-icon-btn" onClick={() => accordionClick(showContent)}>
                            <Icon name={showContent ? 'chevron-up' : 'chevron-down'}
                                color="$color-primary-a2"
                                size='medium'
                            />
                        </button>
                    }
                </div>
            </div>
        </Notifier>
    );
};

export default OutdatedBrowserNotifier;
